module.exports = __webpack_public_path__ + "8bbfbd3f5907e56ca6ef3e38ffb98d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-got-it2.png
// module id = 2026
// module chunks = 4